import { getApps, initializeApp } from 'firebase/app'
import type { FirebaseApp } from 'firebase/app'

import { getFirebaseConfig } from '../config/firebase.config'

const FIREBASE_APP_NAME = 'driver360-notifications'

export const getFirebaseApp = (): FirebaseApp => {
  const existingApp = getApps().find((app) => app.name === FIREBASE_APP_NAME)

  return existingApp ?? initializeApp(getFirebaseConfig(), FIREBASE_APP_NAME)
}
